// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:15:16

export default {
  "id": "squid-escape-but-blockworld",
  "slug": "squid-escape-but-blockworld",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cdef60f561614a7991fa5b0b3515ed85-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cdef60f561614a7991fa5b0b3515ed85/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Squid Escape But Blockworld",
      "description": "You need to escape from the Squid competition, but while running away, you fell into the Block world. It’s a bit hard to escape from the Block world, but don’t stop and keep running. Never stop running until you reach the purple portal. Don’t forget to collect the money you see on the way. Be careful of the big monsters chasing you from behind; they want to catch you, and if they do, you’ll lose.",
      "instructions": "*Use the 'WASD' and 'Arrow keys' to move. \n*To survive, run to the portal at the end of the level and be careful of obstacles.",
      "genres": [
        "Agility"
      ],
      "tags": [
        "2d",
        "2players",
        "arcade",
        "minecraft",
        "squidgame"
      ]
    },
    "zh-CN": {
      "title": "章鱼逃脱但方块世界",
      "description": "你需要逃离章鱼比赛，但在逃跑的过程中，你掉进了方块世界。从方块世界中逃脱有点困难，但不要停下脚步，继续奔跑。直到你到达紫色传送门，永远不要停止奔跑。别忘了沿途收集你看到的金币。小心身后追赶你的大怪物；他们想要抓住你，如果他们做到了，你就会输。",
      "instructions": "*使用\"WASD\"和\"箭头键\"移动。\n*为了生存，跑到关卡末尾的传送门，并小心障碍物。",
      "genres": [
        "敏捷度"
      ],
      "tags": [
        "2D",
        "2人",
        "街机",
        "我的世界",
        "鱿鱼游戏"
      ]
    },
    "zh-TW": {
      "title": "章魚逃亡 但阻止世界",
      "description": "您需要從章魚競賽中逃離，但在逃跑的過程中，您卻墮入了塊塊世界。從塊塊世界中逃離有些困難，但不要停止，繼續奔跑。直到達到紫色通道為止，絕對不要停止奔跑。不要忘了在路上收集您看到的錢幣。小心後面追趕您的巨大怪物；他們想要抓住您，如果成功，您就會輸掉。",
      "instructions": "*使用 'WASD' 和 '箭頭鍵' 移動。\n*為了生存，跑到等級末端的傳送門，並小心障礙物。",
      "genres": [
        "敏捷度"
      ],
      "tags": [
        "2D",
        "2人玩",
        "街機",
        "Minecraft",
        "鬥魚遊戲"
      ]
    },
    "zh-HK": {
      "title": "章魚逃亡 但阻止世界",
      "description": "你需要從章魚比賽中逃離，但在逃跑的過程中，你不慎墮入了積木世界。從積木世界中逃離有些困難，但不要停歇，繼續奔跑。絕不要停止奔跑，直到你到達紫色传送門。不要忘記沿路收集見到的金錢。小心追在你身後的大怪物；他們想要抓住你，如果被他們抓住，你將會輸掉。",
      "instructions": "*使用「WASD」及「方向鍵」移動。\n*要生存下來，請跑到關卡盡頭的通道並小心障礙物。",
      "genres": [
        "靈巧度"
      ],
      "tags": [
        "2D",
        "2人",
        "街機",
        "Minecraft",
        "鬥魚遊戲"
      ]
    },
    "ja": {
      "title": "タコ脱走だがブロックワールド",
      "description": "クジラコンテストから逃げ出す必要がありますが、逃げながら転びてブロックの世界に落ちました。ブロックの世界から逃げ出すのは少し難しいですが、立ち止まらずに走り続けてください。ピンクのポータルに到達するまで、決して止めないでください。道中に見つかるお金はとれなくてはなりません。背後から追いかけてくる大きなモンスターには注意してください；彼らはあなたを捕まえたいですし、もし捕まったら負けます。",
      "instructions": "*「WASD」と「矢印キー」を使用して移動してください。\n*生き延びるためには、レベルの最後にあるポータルに逃げて、障害物に注意してください。",
      "genres": [
        "アグイルティ（敏捷性）"
      ],
      "tags": [
        "2D",
        "2人プレイヤー",
        "アーケード",
        "マインクラフト",
        "スイキッドゲーム"
      ]
    },
    "ko": {
      "title": "오징어 탈출 하지만 블록월드",
      "description": "해치대전에서 탈출해야 합니다만, 도망치는 중에 블록 세계에 빠졌습니다. 블록 세계에서 탈출하는 것은 조금 어렵지만, 멈추지 마시고 계속 달려라. 파란 포털에 도달할 때까지 멈추지 마세요. 길两旁에 보이는 돈을 모두 모아두세요. 뒤에서 쫓아오는 큰 몬스터에 주의하세요; 그들은 너를 잡고 싶어 하며, 잡으면 게임이 끝납니다.",
      "instructions": "* 'WASD'와 '아러아이 키'를 사용하여 이동하세요.\n* 생존하기 위해 레벨 끝의 포털로 달려가고 장애물에 주의하세요.",
      "genres": [
        "기동력"
      ],
      "tags": [
        "2D",
        "2명",
        "아케이드",
        "마인크래프트",
        "키위게임"
      ]
    },
    "fr": {
      "title": "Échappe-toi au Calamar mais Monde de Blocs",
      "description": "Vous devez vous échapper de la compétition de calmar, mais en tentant de s'échapper, vous êtes tombé dans le monde des Blocs. Il est un peu difficile de s'échapper du monde des Blocs, mais ne vous arrêtez pas et continuez à courir. Ne cessez jamais de courir jusqu'à ce que vous atteigniez le portail violet. Ne oubliez pas de ramasser l'argent que vous voyez en chemin. Soyez prudent des grands monstres qui vous chassent des behinds ; ils veulent vous attraper, et s'ils le font, vous perdrez.",
      "instructions": "*Utilisez les touches 'WASD' et les flèches directionnelles pour vous déplacer.\n*Pour survivre, coursez vers le portail à la fin du niveau et soyez prudent avec les obstacles.",
      "genres": [
        "Agilité"
      ],
      "tags": [
        "2d",
        "2 joueurs",
        "arcade",
        "Minecraft",
        "SquidGame"
      ]
    }
  }
};
